import React, { useState } from 'react';
import { useParams } from 'react-router-dom';

const API_URL = process.env.REACT_APP_API_URL;

export default function ResetPasswordBusiness() {
  const { token } = useParams();
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    const res = await fetch(`${API_URL}/api/business/reset-password/${token}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ password }),
    });
    const data = await res.json();
    setMessage(data.message);
  };

  return (
    <div className="container mt-5" style={{ maxWidth: '400px' }}>
      <h3>Yeni Şifre Belirle (İşletme)</h3>
      <form onSubmit={handleSubmit}>
        <input
          type="password"
          className="form-control mt-3"
          placeholder="Yeni şifreniz"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <button type="submit" className="btn btn-success w-100 mt-3">
          Şifreyi Güncelle
        </button>
      </form>
      {message && <p className="text-center mt-3">{message}</p>}
    </div>
  );
}
